import { UsersPage } from 'features/users';

export const TechOperatorUsersPage: React.FC = () => <UsersPage />;
